export const isProduction = () => process.env.APP_ENV === 'production';

export const getDashboardUrl = () => {
  if (isProduction()) {
    return 'https://app.backercamp.com/';
  }
  return 'https://staging-app.backercamp.com/';
};
